import * as ActionTypes from '../ActionTypes';

const initialState = {
    tokenConfigLoading: false,
    tokenConfigData: [],
    error: null,
    canteenRegionsLoading: false,
    canteenRegionsData: [],
};

export const EmployeeCanteenReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_GET_REQUEST:
            return {
                ...state,
                tokenConfigLoading: true,
                tokenConfigData: [],
                error: null,
            };

        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_ADD_REQUEST:
        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_UPDATE_REQUEST:
        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_DELETE_REQUEST:
            return {
                ...state,
                tokenConfigLoading: true,
                error: null,
            };

        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_GET_SUCCESS:
        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_ADD_SUCCESS:
        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_UPDATE_SUCCESS:
        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_DELETE_SUCCESS:
            return {
                ...state,
                tokenConfigLoading: false,
                tokenConfigData: action.payload?.data?.data || [],
                error: null,
            };

        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_GET_ERROR:
        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_ADD_ERROR:
        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_UPDATE_ERROR:
        case ActionTypes.EMPLOYEE_CANTEEN_TOKEN_DELETE_ERROR:
            return {
                ...state,
                tokenConfigLoading: false,
                error: true,
            };
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_GET_REQUEST:
            return {
                    ...state,
                canteenRegionsLoading: true,
                canteenRegionsData: [],
                error: null,
            }
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_ADD_REQUEST:
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_UPDATE_REQUEST:
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_DELETE_REQUEST:
            return {
                ...state,
                canteenRegionsLoading: true,
                error: null,
            };

        case ActionTypes.CANTEEN_MANAGEMENT_REGION_GET_SUCCESS:
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_ADD_SUCCESS:
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_UPDATE_SUCCESS:
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_DELETE_SUCCESS:
            return {
                ...state,
                canteenRegionsLoading: false,
                canteenRegionsData: action.payload?.data?.data,
                error: null,
            };

        case ActionTypes.CANTEEN_MANAGEMENT_REGION_GET_ERROR:
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_ADD_ERROR:
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_UPDATE_ERROR:
        case ActionTypes.CANTEEN_MANAGEMENT_REGION_DELETE_ERROR:
            return {
                ...state,
                canteenRegionsLoading: false,
                error:true,
            };
        default:
            return state;
    }
};
